module.exports = __webpack_public_path__ + "static/media/book_renai_spine.98dd7c53.png";